import { useEffect, useRef, useState } from "react";
import StarRating from "./StarRating";
import Loader from "./Loader";
import { KEY } from "../useMovies";

export default function SelectedMovie({
  selectedID,
  handleCloseMovie,
  onAddWatched,
  watched,
}) {
  const [movie, setMovie] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [userRating, setUserRating] = useState("");

  const isWatched = watched.map((w) => w.imdbID).includes(selectedID);

  const countRef = useRef(0);

  useEffect(
    function () {
      if (!userRating) return;
      countRef.current = countRef.current++;
      console.log(countRef.current);
    },
    [userRating]
  );

  const {
    Title: title,
    Year: year,
    Poster: poster,
    Runtime: runtime,
    imdbRating,
    Plot: plot,
    Released: released,
    Actors: actors,
    Director: director,
    Genre: genre,
  } = movie;

  // if (imdbRating > 8) [isTop, setIsTop] = useState(true);
  // if (imdbRating > 8) return <p>asda</p>;

  // const [avgRating, setAvgRating] = useState(0);

  function handleAdd() {
    const newWatchedMovie = {
      imdbID: selectedID,
      title: title,
      poster: poster,
      year: year,
      imdbRating: Number(imdbRating),
      runtime: Number(runtime.split(" ").at(0)),
      userRating: userRating,
      countRatingDecisions: countRef.current,
    };

    onAddWatched(newWatchedMovie);
    handleCloseMovie();
    // setAvgRating(+imdbRating);
    // setAvgRating((avgRating) => (avgRating + userRating) / 2);
  }

  useEffect(
    function () {
      setIsLoading(true);
      async function getMovieDetails() {
        const res = await fetch(
          `https://www.omdbapi.com/?apikey=${KEY}&i=${selectedID}`
        );

        const data = await res.json();
        setMovie(data);
        setIsLoading(false);
      }
      getMovieDetails();
    },
    [selectedID]
  );

  //Example of "Closure" in JS -> a function always remembers (closures) the variables that are defined before and used within.

  useEffect(
    function () {
      if (!title) return;
      document.title = `MOVIE | ${title}`;

      // Clean-up function (executed when the component is unmounted)
      return function () {
        document.title = "usePopcorn";
      };
    },
    [title]
  );

  useEffect(
    function () {
      function callBack(e) {
        if (e.code === "Backspace") {
          handleCloseMovie();
        }
      }

      document.addEventListener("keydown", callBack);

      return function () {
        document.removeEventListener("keydown", callBack);
      };
    },
    [handleCloseMovie]
  );

  return (
    <div className="details">
      {isLoading ? (
        <Loader />
      ) : (
        <>
          <header>
            <button className="btn-back" onClick={handleCloseMovie}>
              &larr;
            </button>
            <img src={poster} alt={title}></img>
            <div className="details-overview">
              <h2>{title}</h2>
              <p>
                {released} &bull; {runtime}
              </p>
              <p>{genre}</p>
              <p>
                <span>⭐</span> {imdbRating} IMDb rating
              </p>
            </div>
          </header>
          {/* <p>{avgRating}</p> */}
          <section>
            {isWatched ? (
              <button className="btn-add">Already watched ✅</button>
            ) : (
              <div className="rating">
                <StarRating
                  maxRating={10}
                  size={24}
                  setMovieRating={setUserRating}
                />
                {userRating ? (
                  <button className="btn-add" onClick={handleAdd}>
                    + Add to watched list
                  </button>
                ) : (
                  <p
                    className="btn-add"
                    style={{
                      textAlign: "center",
                    }}
                  >
                    Give a rating!
                  </p>
                )}
              </div>
            )}

            <p>
              <em>{plot}</em>
            </p>
            <p>Starring: {actors}</p>
            <p>Directed by {director}</p>
          </section>
        </>
      )}
    </div>
  );
}
